import { makeAutoObservable } from "mobx";

import { ajaxController } from "./AjaxController";
import { Country } from "../DTOs/Address/Country";

export class CountryAjaxController {
  private _ajaxController = ajaxController
  private countryEndpoint = "country"

  getCountries() {
    return this._ajaxController.get<Country[]>(
      `${this.countryEndpoint}`,
      {},
      Country
    )
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const countryAjaxController = new CountryAjaxController();